import { yupResolver } from '@hookform/resolvers/yup'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { Button } from 'shared/components/Button/Button'
import { TextInput } from 'shared/components/TextInput/TextInput'
import { bgGray } from 'shared/theme/colors'
import { object, string } from 'yup'

interface DebtWriteOffFormProps {
  onSubmit: (data: DebtWriteOffFormValues) => void
  onCancel: () => void
  isLoading: boolean
  confirmReady: boolean
}

export interface DebtWriteOffFormValues {
  amount: string
}

const DebtWriteOffFormSchema = () =>
  object().shape({
    amount: string().test(function (value) {
      if (!value) {
        return this.createError({ message: 'Amount is required' })
      }

      if (isNaN(parseFloat(value))) {
        return this.createError({ message: 'Amount must be a number' })
      }

      if (parseFloat(value) <= 0) {
        return this.createError({ message: 'Amount must be greater than 0' })
      }

      return true
    }),
  })

export function DebtWriteOffForm({ onSubmit, onCancel, isLoading, confirmReady }: DebtWriteOffFormProps) {
  const { control, handleSubmit } = useForm<DebtWriteOffFormValues>({
    mode: 'onSubmit',
    defaultValues: {
      amount: '',
    },
    resolver: yupResolver(DebtWriteOffFormSchema()),
  })

  return (
    <FlexBox isColumn gap="4px" isFullWidth alignItems="stretch">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          render={({ field, fieldState }) => (
            <TextInput
              {...field}
              label="Amount"
              backgroundColor={bgGray}
              error={fieldState.error?.message}
              inputMode="numeric"
              isCurrency
            />
          )}
          control={control}
          name="amount"
        />

        <FlexBox isColumn isFullWidth justifyContent="center" alignItems="center" mt={9}>
          <Button type="submit" variant="primary" isLoading={isLoading} isDisabled={!confirmReady} mb={1}>
            Confirm
          </Button>
          <Button variant="flat" onClick={onCancel}>
            Cancel
          </Button>
        </FlexBox>
      </form>
    </FlexBox>
  )
}
